import { render, staticRenderFns } from "./showThird.vue?vue&type=template&id=36749e5c&scoped=true&"
import script from "./showThird.vue?vue&type=script&lang=js&"
export * from "./showThird.vue?vue&type=script&lang=js&"
import style0 from "./showThird.vue?vue&type=style&index=0&id=36749e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36749e5c",
  null
  
)

export default component.exports